import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import $ from 'jquery';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';
import { NumberValidatorDirective } from '@form-field-module/common/directives/number-validator.directive';

@Component({
    selector: 'sb-number-input',
    templateUrl: './number-input.component.html',
    styleUrls: ['./number-input.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FocusDirective, FormsModule, FormFieldLabelComponent, NumberValidatorDirective],
})
export class NumberInputComponent implements OnInit, AfterViewInit {
    @Input() formField: Field | ClientField;

    placeholder: string;
    maxLength: number;
    minLength: number;

    constructor(public formService: FormService) {}

    ngOnInit() {
        if (this.formField.value || this.formField.value === 0) {
            this.formField.value = this.formField.value.toString().replace(/,/g, '.');
        }

        this.maxLength = +this.formField.options?.maxNumber || Number.MAX_VALUE;
        this.minLength = +this.formField.options?.minNumber || 0;

        if (this.formField.value && this.formField.value.length > this.maxLength) {
            this.formField.value = this.formField.value.slice(0, this.maxLength);
        }
    }

    ngAfterViewInit() {
        $('#form-field-' + this.formField.id)
            .on('paste', (event: any) => {
                const pastedData = (event.clipboardData || event.originalEvent.clipboardData).getData('text');

                this.preventPastingNotNumberValue(pastedData, event);
            })
            .on('drop', (event: any) => {
                const pastedData = event.originalEvent.dataTransfer.getData('text');

                this.preventPastingNotNumberValue(pastedData, event);
            });
    }

    onInput(element) {
        if (element.target.value) {
            element.target.value = element.target.value.replace(/,/g, '.');

            if (element.target.value.length > this.maxLength) {
                element.target.value = element.target.value.slice(0, this.maxLength);
            }

            this.formField.value = element.target.value;
        }
    }

    onKeyDown(event) {
        if (HelperService.isKeyAllowedForNumberField(event)) {
            // let it happen, don't do anything
            return;
        } else {
            // Ensure that it is a number
            this.preventPastingNotNumberValue(event.key, event);
        }
    }

    private preventPastingNotNumberValue(testedValue, event) {
        if (!/^[\d,e.+-]+$/.test(testedValue)) {
            event.preventDefault();
        }
    }
}
